function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M226.57.17L55 170.72h63.67l-49 129.45 175.71-170.62h-63.66zm0 0",
  fill: "#fff"
});

var SvgThunderbolt = function SvgThunderbolt(props) {
  return React.createElement("svg", _extends({
    "data-name": "Capa 1",
    viewBox: "0 0 300 300"
  }, props), _ref);
};

export default SvgThunderbolt;